module.exports = __webpack_public_path__ + "img/careers_communication.94ea2da9.png";